module.exports = __webpack_public_path__ + "static/img/1535_phase_function_Paper_PointsHejduk_Prediction.6541875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1535_phase_function_Paper_PointsHejduk_Prediction.png
// module id = leVv
// module chunks = 0